<template>
    <div>
        <div>Checkout</div>
        <!-- <div><div v-model="val.user_name"></div></div> -->
        <form @submit.prevent="urlAction" method="POST" ref="form">
            <input type="hidden" custom="Hidden Element" name="hidden">
        </form>
    </div>
</template>

<script>

export default {
    name: 'Checkout',
    props: ['orderData'],
    data() {
        return {
        }
    },
    mounted() {
        console.log(this.orderData);
        var me = document.createElement('script');
        me.setAttribute('type','application/javascript');
        me.setAttribute('src',"https://checkout.razorpay.com/v1/checkout.js");
        me.setAttribute('data-key',this.orderData.rkey);
        me.setAttribute('data-amount',this.orderData.amount);
        me.setAttribute('data-currency',this.orderData.currency);
        me.setAttribute('data-order_id',this.orderData.order_id);
        me.setAttribute('data-buttontext','Pay with Razorpay');
        me.setAttribute('data-name','Lysten Ecomm');
        me.setAttribute('data-image',"https://lysten-ai-icons.s3.ap-south-1.amazonaws.com/img/logos/main_logo_blue.png");
        me.setAttribute('data-prefill.name',this.orderData.uname);
        me.setAttribute('data-prefill.email',this.orderData.email);
        me.setAttribute('data-theme.color','#F37254');
        this.$refs.form.prepend(me);
    },
    methods: ({
        urlAction(){
            // console.log(event);
            // setTimeout(function(){
            //     console.log('in timer');
            // }, 3000);
            // console.log(this.$route.query.razorpay_payment_id);
            this.$router.push({ path : '/' + this.$route.params.store_slug + '/checkout/confirm'})
        }
    })
}
</script>
